import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const ClassProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Classes/${props.classId}`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Classes/${props.classId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        let url = 'Classes';

        if (!_.isEmpty(props) && _.isBoolean(props.national)) { url += `?national=true`; }

        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);  

    const value = { selectRecord, listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useClassesStore = () => React.useContext(Context);
